import { Onboarding } from '@com-delta-idp/mnx-skymiles-overview-ui';
import {
  MultiplePersonalizationEngineResponse,
  OnboardingContent,
  PEOnboarding,
  UserSession,
  getEmptyContent,
  getLink,
  isDisplay,
  isError,
  isValidData
} from '@com-delta-idp/mnx-skymiles-shared';
import { logError } from '@com-delta-idp/mnx-utils';

export const getOnboarding = (
  featureFlag: boolean | undefined,
  userSession: UserSession | undefined,
  personalizationEngine: MultiplePersonalizationEngineResponse | undefined,
  errors: string | undefined
): Onboarding => {
  try {
    if (errors) {
      return isError<Onboarding>('', undefined, featureFlag);
    }
    return isValidData<
      MultiplePersonalizationEngineResponse,
      [
        MultiplePersonalizationEngineResponse | undefined,
        UserSession | undefined,
        boolean | undefined
      ]
    >(
      'ng-skymiles:micro-moments-v1',
      personalizationEngine,
      userSession,
      featureFlag
    )
      ? isValidOnboard(
          personalizationEngine as MultiplePersonalizationEngineResponse,
          userSession as UserSession,
          featureFlag as boolean
        )
      : isDisplay<Onboarding>(featureFlag);
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'OVERVIEW', 'ONBOARDING');
    return getEmptyContent<Onboarding>('', [], true, true);
  }
};

const isValidOnboard = (
  personalizationEngine: MultiplePersonalizationEngineResponse,
  userSession: UserSession,
  featureFlag: boolean
) => {
  const onboarding =
    personalizationEngine['ng-skymiles:micro-moments-v1'].parsys
      .onboardingmodal;
  if (featureFlag && onboarding) {
    return adaptOnboarding(
      personalizationEngine['ng-skymiles:micro-moments-v1'].parsys
        .onboardingmodal as PEOnboarding,
      userSession,
      featureFlag
    );
  }
  return getEmptyContent<Onboarding>('', [], true, true);
};

const adaptOnboarding = (
  onboarding: PEOnboarding,
  userSession: UserSession,
  featureFlag: boolean
): Onboarding => {
  return {
    title: `${onboarding.title} ${userSession.firstName}.`,
    subtitle: `${onboarding.subtitle}${userSession.smNumber}`,
    label: onboarding.label,
    items: getOnboardingItems(onboarding.items),
    action: {
      label: ''
    },
    close: {
      path: onboarding.closePath,
      alt: onboarding.closeAltText
    },
    ariaLabel: {
      close: onboarding.closeAriaLabel
    },
    disabled: !featureFlag,
    loaded: true
  };
};

const getOnboardingItems = (onboardingItems: string[]) => {
  return onboardingItems.map((onboard) => {
    const onboardData = JSON.parse(onboard);
    return {
      title: onboardData.title,
      description: onboardData.description,
      logo: {
        src: onboardData.logoSrc,
        alt: onboardData.logoAlt
      },
      link: getLink(onboardData.linkLabel, getUrl(onboardData)),
      axLink: onboardData.axLink + ' '
    };
  });
};

const getUrl = (onboard: OnboardingContent): string => {
  if (isIphone(onboard)) {
    return onboard.mobileIos;
  } else if (isAndroid(onboard)) {
    return onboard.mobileAndroid;
  }
  return onboard.linkUrl;
};

const isIphone = (onboard: OnboardingContent) => {
  return /iPad|iPhone/.test(navigator.userAgent) && onboard.mobileIos;
};

const isAndroid = (onboard: OnboardingContent) => {
  return /android/i.test(navigator.userAgent) && onboard.mobileAndroid;
};
